import { render } from "./CardDetailView.vue?vue&type=template&id=443fe321&scoped=true"
import script from "./CardDetailView.vue?vue&type=script&lang=js"
export * from "./CardDetailView.vue?vue&type=script&lang=js"

import "./CardDetailView.vue?vue&type=style&index=0&id=443fe321&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-443fe321"]])

export default __exports__